import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import config from '../../config';

import styles from './HomePage.css';

class HomePage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        menuItems: PropTypes.node,
        children: PropTypes.node,
    };

    state = {
        drawerOpen: false,
    };

    handleAppbarIconClick = () => {
        this.setState({ drawerOpen: !this.state.drawerOpen });
    };

    handleDrawerOpenChange = drawerOpen => {
        this.setState({ drawerOpen });
    };

    handleExitClick = () => {
        fetch(`${config.backend}/login`, {
            method: 'DELETE',
            credentials: 'include',
        })
            .then(() => {
                window.location = '/';
            })
            .catch(() => {
                window.location = '/';
            });
    };

    render() {
        const {
            intl: { formatMessage },
            menuItems,
            children,
        } = this.props;

        return (
            <Fragment>
                <AppBar
                    title={formatMessage({ id: 'OrgHomePage.TofT' })}
                    onLeftIconButtonClick={this.handleAppbarIconClick}
                />
                <Drawer docked={false} open={this.state.drawerOpen} onRequestChange={this.handleDrawerOpenChange}>
                    {menuItems}
                    <MenuItem onClick={this.handleExitClick}>
                        <FormattedMessage id="OrgHomePage.Exit" />
                    </MenuItem>
                </Drawer>
                <Paper className={styles.paper}>{children}</Paper>
            </Fragment>
        );
    }
}

export default injectIntl(HomePage);



// WEBPACK FOOTER //
// ./src/Pages/HomePage/HomePage.js